import axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { alertInfoTypes } from "shared-components/src/components/feedback/alertInfoTypes.enum";
import { showAlertInfo } from "shared-components/src/components/feedback/store/alertInfo.actions";
import {
  hideProgress,
  showProgress,
} from "shared-components/src/components/feedback/store/circularProgress.actions";
import { API_WATER_AUTHORITY } from "../../config/api";
import {
  FETCH_WATER_AUTHORITY_REQUEST,
  UPDATE_WATER_AUTHORITY_REQUEST,
  fetchWaterAuthorityFailure,
  fetchWaterAuthorityRequest,
  fetchWaterAuthoritySuccess,
  updateWaterAuthorityFailure,
  updateWaterAuthoritySuccess,
} from "../../store/actions/waterAuthority.actions";

const getWaterAuthority = async (token, id) => {
  const url = `${API_WATER_AUTHORITY}/${id}`;
  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

function* handleWaterAuthority(action) {
  try {
    const token = yield select((state) => state.auth.token);
    const id = action?.payload;
    const response = yield call(getWaterAuthority, token, id);
    yield put(fetchWaterAuthoritySuccess(response.data));
  } catch (error) {
    yield put(
      showAlertInfo({ type: alertInfoTypes.ERROR, message: error.message })
    );
    yield put(hideProgress());
    yield put(fetchWaterAuthorityFailure(error.message));
  }
}

export default function* watchGetWaterAuthority() {
  yield takeLatest(FETCH_WATER_AUTHORITY_REQUEST, handleWaterAuthority);
}

const updateWaterAuthority = async (token, payload, waterAuthorityId) => {
  const url = `${API_WATER_AUTHORITY}/${waterAuthorityId}`;
  const data = payload.attributes;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const response = await axios.put(url, { data }, { headers });
  return response.data;
};

function* handleUpdateWaterAuthority(action) {
  try {
    yield put(showProgress());
    const token = yield select((state) => state.auth.token);
    const waterAuthorityId = yield select(
      (state) => state.waterAuthority.data.id
    );
    const response = yield call(
      updateWaterAuthority,
      token,
      action.payload,
      waterAuthorityId
    );
    yield put(updateWaterAuthoritySuccess(response));
    yield put(fetchWaterAuthorityRequest(waterAuthorityId));
    yield put(hideProgress());
  } catch (error) {
    yield put(
      showAlertInfo({
        type: alertInfoTypes.ERROR,
        message: error?.response?.data?.error?.message ?? error.message,
      })
    );
    yield put(updateWaterAuthorityFailure(error.message));
    yield put(hideProgress());
  }
}

export function* watchUpdateWaterAuthority() {
  yield takeLatest(UPDATE_WATER_AUTHORITY_REQUEST, handleUpdateWaterAuthority);
}
